import React, { Component } from 'react';
import { Col,  FormControl } from 'react-bootstrap';

/**
* Class TextFilter
* Generic component to generate text filters
**/
class TextFilter extends Component {
  /**
  * props
  * title : title of the field
  * name : reference name prefix
  * parentFilter : parent filter reference
  **/

  /**
  * constructor
  * Constructor
  **/
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.state = {
      value: ""
    };
  }

  /**
  * render
  * Rendering component function : display the text filter
  **/
  render() {
    const textfieldProps = {
      type: "text",
      onChange: this.handleChange,
      ref: "textfield",
      value: this.state.value,
      id: this.props.name,
      placeholder: this.props.title
    };

    // Form rendering
    return(
      <Col componentClass="filterTextField" sm={2}><FormControl {...textfieldProps} /></Col>
    );

    // return(
    //   <FormGroup>
    //     <Col componentClass="filterTextLabel" sm={2}><ControlLabel>{this.props.title}</ControlLabel></Col>
    //     <Col componentClass="filterTextField" sm={2}><FormControl {...textfieldProps} /></Col>
    //   </FormGroup>
    // );
  }

  /**
  * handleChange
  * Call the handleChange of the parent
  **/
  handleChange(e) {
    const value = e.target.value
    this.setState({value: value});
    this.props.parentFilter.handleChange(this, value);
  }

  /**
  * reset
  * Reset the value
  **/
  reset() {
    this.setState({value: ""});
  }

}

export default TextFilter;



// WEBPACK FOOTER //
// ./src/views/Helper/GridFilter/TextFilter.js